<dl class='datepicker-container' *ngIf="hide && loaded">
  <dt>{{ title|translate }}</dt>
  <dd>
    <a #dp="bsDaterangepicker" bsDaterangepicker readonly
      container="{{ container }}" [placement]="placement" [outsideClick]="true" [bsConfig]="bsConfig"
      (bsValueChange)="selectDateRange($event)">{{ label|translate }}</a>
  </dd>
</dl>